fragment StoryInsightFields on StoryInsight {
  id
  igExits
  igImpressions
  igReach
  igReplies
  igTapsForward
  igTapsBackward
}
